"use client";

import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/shared/lib/api";
import { MvpCard, type TournamentMvp } from "./mvp-card";

/**
 * KAN-807: контейнер карточки MVP — единственное место, где она ходит за данными.
 *
 * Сама `MvpCard` чистая: получает объект и рисует. Так её можно проверить тестами
 * без мока сети, а страница итогов (KAN-878) сможет отдать ей уже загруженный
 * объект, не делая второй запрос.
 *
 * Блок целиком исчезает, если MVP нет: пустая карточка «MVP: —» выглядит поломкой,
 * а по такому турниру статистики просто нет.
 */
async function fetchMvp(tournamentId: string): Promise<TournamentMvp | null> {
  const res = await api.get<TournamentMvp | null>(
    `/tournaments/${encodeURIComponent(tournamentId)}/mvp`,
  );
  return res.data ?? null;
}

export const tournamentMvpQuery = (tournamentId: string) =>
  queryOptions({
    queryKey: ["tournaments", tournamentId, "mvp"],
    queryFn: () => fetchMvp(tournamentId),
    staleTime: 30_000,
    retry: false,
  });

export function TournamentMvpSection({ tournamentId }: { tournamentId: string }) {
  const { data: mvp, isLoading } = useQuery({
    ...tournamentMvpQuery(tournamentId),
    enabled: Boolean(tournamentId),
  });

  if (isLoading || !mvp) return null;

  return <MvpCard mvp={mvp} />;
}
